import * as yup from 'yup'

// const validatePix = (value: string | null | undefined): boolean => {
//   const pixValue = value ?? ''
//   const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(pixValue)
//   const isValidPhoneNumber = /^\d{10,11}$/.test(pixValue)
//   const isValidRandomKey = /^[a-zA-Z0-9]{32}$/.test(pixValue)

//   return (
//     isValidEmail || isValidPhoneNumber || isValidRandomKey || pixValue === ''
//   )
// }

const validateBankBranch = (value: string | null | undefined): boolean => {
  const bankBranchValue = value ?? ''
  const isValidBankBranch = /^[0-9]{4}(-[0-9])?$/.test(bankBranchValue)

  return isValidBankBranch || bankBranchValue === ''
}

export const validateBankDataOrPixIsFilled = (value: any) => {
  if (!value) return false

  const { bank, bankBranch, currentAccount, pix } = value

  const bankDataFilled =
    bank &&
    bank.trim() !== '' &&
    bankBranch &&
    bankBranch.trim() !== '' &&
    currentAccount &&
    currentAccount.trim() !== ''

  const pixFilled = pix && pix.trim() !== ''

  return !!(bankDataFilled || pixFilled)
}

export const bankDataSchema = yup.object({
  bank: yup.string().nullable(),
  bankBranch: yup
    .string()
    .nullable()
    .test('is-valid-bank-branch', 'INVALID_FIELD', validateBankBranch),
  currentAccount: yup
    .string()
    .nullable()
    .max(11, 'INVALID_NUMBER_OF_CHARACTERS'),
  pix: yup.string().nullable(),
})
